import { render, staticRenderFns } from "./DetailProuct.vue?vue&type=template&id=2bf72840&scoped=true&"
import script from "./DetailProuct.vue?vue&type=script&lang=js&"
export * from "./DetailProuct.vue?vue&type=script&lang=js&"
import style0 from "./DetailProuct.vue?vue&type=style&index=0&id=2bf72840&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf72840",
  null
  
)

export default component.exports